function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';

class Points extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getClassName", (id, serieId) => {
      const _this$props = this.props,
            currentPoint = _this$props.currentPoint,
            currentSlice = _this$props.currentSlice;
      let classNames = [];
      const pointClass = "point--" + id.toString().replace('.', '-');
      const serieClass = "serie--" + serieId.toString().replace('.', '-');
      classNames.push('point');
      classNames.push(pointClass);
      classNames.push(serieClass);
      let isCurrent;

      if (currentPoint && currentPoint.id && currentPoint.id === id) {
        isCurrent = true;
      }

      if (currentSlice && currentSlice.points) {
        const inCurrentSlice = currentSlice.points.filter(point => {
          if (point.id === id) {
            return true;
          }
        });

        if (inCurrentSlice.length) {
          isCurrent = true;
        }
      }

      if (isCurrent) {
        classNames.push('point--is-current');
      }

      return classNames.join(' ');
    });

    _defineProperty(this, "renderPoint", (point, index) => {
      const id = point.id,
            serieId = point.serieId,
            serieColor = point.serieColor,
            x = point.x,
            y = point.y;
      const className = this.getClassName(id, serieId);
      const transform = "translate(" + x + ", " + y + ")";
      return React.createElement("circle", {
        transform: transform,
        className: className,
        r: "2",
        fill: "transparent",
        stroke: serieColor,
        strokeWidth: "4"
      });
    });
  }

  render() {
    const points = this.props.points;
    return React.createElement("g", {
      className: "points"
    }, points.map(this.renderPoint));
  }

}

export default Points;